// we need to separate this from the apprentices since the apprentice id can be undefined
// so we detangle code logic here
import {t} from 'i18next'
import {ColumnFilterElementTemplateOptions} from 'primereact/column'
import {Dropdown} from 'primereact/dropdown'
import React from 'react'
import {Person} from '../../../model/person.model'
import {findPersonById} from '../../../util/arraySearch'
import {AvatarWithName} from '../AvatarWithName'

const employeeOptionFilterTemplate = (id: number, employees: Person[]) => {
  let p = findPersonById(id, employees)
  if (!p) {
    return t<string>('core.all')
  }
  return <AvatarWithName person={p} />
}

export const EmployeeDataTableFilter = (
  options: ColumnFilterElementTemplateOptions,
  employees: Person[]
): JSX.Element => {
  const filterValues = employees.map((employee) => {
    return {
      label: employee.full_name,
      value: employee.person_id,
    }
  })

  return (
    <Dropdown
      value={options.value}
      options={filterValues}
      valueTemplate={(_) =>
        employeeOptionFilterTemplate(options.value, employees)
      }
      itemTemplate={(e) => employeeOptionFilterTemplate(e.value, employees)}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder={t<string>('core.all')}
      filter
      style={{
        height: 40,
        minHeight: 40,
        width: '100%',
        minWidth: '100%',
        maxWidth: 40,
      }}
      className="p-column-filter"
    />
  )
}